import QuestionModel from "../QuestionModel";
import QuestionValue from "../QuestionValue";
import QuestionModule from "./QuestionModule";

export default class QuestionModuleMultiples extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);
        question.options = this.generateOptions(question, data.values, data.multiplierRange);
        return question;
    }

    generateOptions(question, count, multiplierRange) {
        const value = P3.math.randomInt(question.range.min, question.range.max);
        question.values.push(new QuestionValue(value));
        const options = [];

        const correctAnswers = P3.math.randomInt(1, Math.max(1, count - 1));
        const correctMultiples = [];
        for (let i = multiplierRange.min; i <= multiplierRange.max; i++) {
            correctMultiples.push(value * i);
        }
        let answer = 0;
        const incorrectAnswers = [];
        for (let i = 0; i < count; i++) {
            let v;
            if (i < correctAnswers) {
                v = correctMultiples.splice(P3.math.randomInt(0, correctMultiples.length - 1), 1)[0];
                answer += v;
            } else {
                v = value;
                while (this.isAMultipleOf(value, v) || incorrectAnswers.indexOf(v) > -1) {
                    v = P3.math.randomInt(value * multiplierRange.min, value * multiplierRange.max);
                }
                incorrectAnswers.push(v);
            }
            options.push(new QuestionValue(v));
        }
        P3.utils.shuffleArray(options);

        question.part = [];
        for (let i in options) {
            if (this.isAMultipleOf(value, options[i]))
                question.part.push(Number(i));
        }

        return options;
    }

    isAMultipleOf(a, b) {
        return (b % a === 0);
    }
}